export default __webpack_public_path__ + "static/media/m_quiz_bg_1.92c84bc8.png";